import { render } from "./DashboardAnalytics.vue?vue&type=template&id=1aa76e66&scoped=true"
import script from "./DashboardAnalytics.vue?vue&type=script&lang=js"
export * from "./DashboardAnalytics.vue?vue&type=script&lang=js"

import "./DashboardAnalytics.vue?vue&type=style&index=0&id=1aa76e66&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa76e66"]])

export default __exports__